<template>
  <div
    class="bg-grey-lighter rounded-lg mt-3 transition"
    :class="{
      'opacity-50': disabled,
      'cursor-pointer hover:bg-grey-light': clickable && !disabled,
    }"
    @click="handleClick"
  >
    <div class="flex flex-row items-center justify-between p-3">
      <span class="font-semibold text-sm flex-1 min-w-0 break-words pr-2">
        {{ formatTitle(title) }}
      </span>

      <div v-show="!disabled" class="flex flex-col text-right flex-shrink-0 whitespace-nowrap">
        <div class="flex flex-row items-center justify-end whitespace-nowrap">
          <span
            class="font-bold text-sm mb-1 whitespace-nowrap"
            :class="[`text-${text_color}`, disabled ? 'text-gray-400' : '']"
          >
            {{ displayBalance }}
          </span>

          <img
            :src="
              require(`@/assets/icons/${
                show_balance
                  ? 'papsi_password_visible.svg'
                  : 'papsi_password_invisible.svg'
              }`)
            "
            class="w-4 h-4 ml-1 flex-shrink-0"
            :class="{
              'cursor-pointer': !disabled,
              'cursor-not-allowed opacity-50': disabled,
            }"
            @click.stop="toggleBalance"
          />
        </div>

        <span class="text-xxs text-muted whitespace-nowrap">
          As of {{ formatShortDate(as_of) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin';

export default {
  name: "BalanceDisplayControl",
  mixins: [mixin],

  props: {
    code: {
      type: String,
      default: "SAV",
    },

    title: {
      type: String,
      default: "Regular Savings Deposit",
    },

    balance: {
      type: Number,
      default: 1000000,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    text_color: {
      type: String,
      default: "primary",
    },

    show_default: {
      type: Boolean,
      default: false,
    },

    clickable: {
      type: Boolean,
      default: false,
    },

    href: {
      type: String,
      default: "",
    },

    as_of: {
      type: String,
      default: () => {
        const today = new Date();

        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        const year = today.getFullYear();

        return `${month}/${day}/${year}`;
      },
    },
  },

  data() {
    return {
      show_balance: this.show_default,
    };
  },

  computed: {
    displayBalance() {
      return this.show_balance
        ? `₱${this.formatBalance(this.balance)}`
        : "₱*****";
    },
  },

  methods: {
    handleClick() {
      if (this.disabled || !this.clickable || !this.href) return;

      this.$router.push(this.href);
    },

    toggleBalance() {
      if (this.disabled) return;

      this.show_balance = !this.show_balance;
    },

    formatTitle(value) {
      return String(value)
        .toLowerCase()
        .replace(/\b\w+\b/g, (word) => {
          return word === "to"
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1);
        });
    },

    formatBalance(value) {
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>